import './SvcTemplate.css';
import SlideItem from "../SlideItem";
import {createRef, useEffect} from "react";
import gsap from "gsap";
import {getSpan, isPortrait} from "../../Utilities/utils";
import * as PropTypes from "prop-types";
import Slider from "react-slick";
import React, { Fragment } from 'react'


const SvcTemplate = (props) => {
    const line = createRef();
    const sl = props.slides.length - 1;
    const pfx = props.id + '-title-';

    useEffect(() => {
        const titleId = pfx + (props.mainText.length - 1);
        const title = document.getElementById(titleId);
        if (title) {
            let lineWidth = title.offsetWidth * 1.1;
            gsap.set(line.current, {width: lineWidth});
        }
    });

    function getItem(index, value, w = 'fit-content', h = 'fit-content') {
        return <SlideItem key={'si' + index} id={props.id + index}
                          className={'svc-slide-item'}
                          height={h}
                          width={w}
                          title={value.title}
                          fontTitle={'svc-slide-title'}
                          subTitle={value.subTitle}
                          metrics={value.metrics}
                          fontSubtitle={'svc-slide-subtitle'}
                          clickEvent={() => {
                          }}>
            <div className={"slide-header"}>{value.header}</div>
        </SlideItem>;
    }

    let settings = {
        dots: true,
        infinite: false,
        speed: 600,
        slidesToScroll: 1,
        slidesToShow: 1,
        vertical: false,
        adaptiveHeight: false,
        arrows: false,
        centerMode: true,
        variableWidth: false,
        centerPadding: '15px'
    };

    return (
        <section className={"service-page"}>
            <div className={'p-services-content-template'}>
                <div className={"svc-title"}>
                    {isPortrait() ? getSpan(props.mainText, pfx, ' ')
                        : getSpan(props.mainText, pfx)}
                    <div ref={line} className={"svc-first-line purple accessibility-line"}/>
                </div>
                {isPortrait() ?
                    <Slider className={"slides accessibility-img"}
                            {...settings}>
                        {props.slides.map((value, index) => {
                                return <div key={index}>{getItem(index, value, '100vw')}</div>
                            }
                        )}
                    </Slider>
                    : <>
                        <div className={"svc-subtitle accessibility-font"}>
                            {getSpan(props.contentText)}
                        </div>

                        <div className={"slides accessibility-img"}>
                            {props.slides.map((value, index) => <React.Fragment key={index}>
                                {getItem(index, value)}
                                {(index < sl) && <div key={"sep" + index} className={'sep'}/>}
                            </React.Fragment>)}
                        </div>
                    </>}
            </div>
            {props.children}
        </section>
    )
}

SvcTemplate.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    mainText: PropTypes.arrayOf(PropTypes.string).isRequired,
    contentText: PropTypes.arrayOf(PropTypes.string).isRequired,
    slides: PropTypes.arrayOf(PropTypes.object),
    children: PropTypes.element,
}

SvcTemplate.defaultProps = {
    className: '',
}

export default SvcTemplate;
